<template>
  <div>
    <p v-if="label">{{label}}</p>

    <v-combobox
      v-model="tags"
      label=""
      :placeholder="$t('components.common.addItem')"
      :hint="$t('components.common.addTagsHint')"
      multiple
      chips
      deletable-chips
      @input="tagsChanged($event)"
      :disabled="disabled"
    ></v-combobox>
  </div>
</template>

<script>
export default {
  props: {
    disabled: false,
    label: ''
  },

  data() {
    return {
      tags: [],
      originalTags: []
    };
  },

  methods: {
    setTags(tags) {
      this.originalTags = tags.slice();
      this.tags = tags.slice();
    },

    tagsChanged($event) {
      let addedTag;
      let removedTag;

      addedTag = this.tagsAdded();

      if (!!addedTag) {
        this.$emit('add', addedTag);
        return;
      }

      removedTag = this.tagsRemoved();

      if (!!removedTag) {
        this.$emit('remove', removedTag);
      }
    },

    tagsAdded() {
      let tagsAdded = undefined;

      this.tags.forEach(tag => {
        const exists = this.originalTags.some(orgTag => orgTag === tag);
        if (!exists) {
          tagsAdded = tag;
          this.originalTags.push(tag);
        }
      });

      return tagsAdded;
    },

    tagsRemoved() {
      let tagsRemoved = undefined;

      this.originalTags.forEach(orgTag => {
        const existsIndex = this.tags.indexOf(orgTag);
        if (existsIndex < 0) {
          tagsRemoved = orgTag;
          this.originalTags.splice(this.originalTags.indexOf(orgTag), 1);
        }
      });

      return tagsRemoved;
    }
  }
}
</script>
